import { render, staticRenderFns } from "./DescargasScraperXMLS.vue?vue&type=template&id=57d63789&scoped=true&"
import script from "./DescargasScraperXMLS.vue?vue&type=script&lang=js&"
export * from "./DescargasScraperXMLS.vue?vue&type=script&lang=js&"
import style0 from "./DescargasScraperXMLS.vue?vue&type=style&index=0&id=57d63789&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d63789",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QSelect,QBtn,QIcon,QSpinner,QList,QItem,QItemSection,QDialog,QCard,QCardSection,QSpace});qInstall(component, 'directives', {ClosePopup});
